import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "carousel__item" }
const _hoisted_4 = { class: "titre" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "close-text" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "nb-notifications"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_openBlock(), _createBlock(_Transition, { name: "slide" }, {
    default: _withCtx(() => [
      (_ctx.displayActus && _ctx.closedFromParent && !_ctx.isModalChoixPortailOuverte)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "elevation",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.displayOrHideActus && _ctx.displayOrHideActus(...args)))
          }, [
            _createElementVNode("div", {
              class: "container-actualites box-shadow",
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h3", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t('home.actualites.header')) + " ", 1),
                  _createVNode(_component_ReglePastille, {
                    cle: "dashboard.actualites",
                    placement: "bottom"
                  }),
                  _createVNode(_component_ReglePastille, {
                    cle: "dashboard.actualiteLectureAutomatique",
                    placement: "bottom"
                  })
                ])
              ]),
              _createVNode(_component_Carousel, {
                settings: _ctx.settings,
                itemsToShow: 1,
                onSlideStart: _ctx.handleSlideStart,
                onInit: _ctx.handleInit
              }, {
                addons: _withCtx(() => [
                  _createVNode(_component_Pagination),
                  _createVNode(_component_Navigation)
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actualites, (slide) => {
                    return (_openBlock(), _createBlock(_component_Slide, {
                      key: slide.id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("img", {
                            src: _ctx.actualitesImagesLocation + slide.nomImage,
                            class: "image",
                            alt: "image"
                          }, null, 8, _hoisted_2),
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("h2", _hoisted_4, _toDisplayString(slide.titre), 1),
                            _createElementVNode("div", {
                              innerHTML: slide.contenu,
                              class: "texte"
                            }, null, 8, _hoisted_5)
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["settings", "onSlideStart", "onInit"]),
              _createElementVNode("button", {
                class: "vertical-button close-button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.displayOrHideActus && _ctx.displayOrHideActus(...args)))
              }, [
                _createElementVNode("img", {
                  class: "close-icon",
                  src: _ctx.closeIcon,
                  alt: "close"
                }, null, 8, _hoisted_6),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('home.actualites.close')), 1)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("button", {
              class: "vertical-button open-button",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.displayOrHideActus && _ctx.displayOrHideActus(...args)))
            }, _toDisplayString(_ctx.$t('home.actualites.open')), 1),
            (_ctx.nbNouvellesActualites !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.nbNouvellesActualites), 1))
              : _createCommentVNode("", true)
          ]))
    ]),
    _: 1
  }))
}